var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Action, Selector, Store, Actions } from '@ngxs/store';
import { AddText } from './text.actions';
import { TextToolService } from '../../../image-editor/tools/text/text-tool.service';
import { CloseForePanel, OpenPanel } from '../../../image-editor/state/editor-state-actions';
import { HistoryNames } from '../../../image-editor/history/history-names.enum';
import { HistoryToolService } from '../../../image-editor/history/history-tool.service';
import { BaseToolState } from '../base-tool.state';
import { DrawerName } from '../../toolbar-controls/drawers/drawer-name.enum';
var TEXT_STATE_DEFAULTS = {
    dirty: false,
};
var TextState = /** @class */ (function (_super) {
    __extends(TextState, _super);
    function TextState(textTool, store, history, actions$) {
        var _this = _super.call(this) || this;
        _this.textTool = textTool;
        _this.store = store;
        _this.history = history;
        _this.actions$ = actions$;
        _this.toolName = DrawerName.TEXT;
        return _this;
    }
    TextState.dirty = function (state) {
        return state.dirty;
    };
    TextState.prototype.add = function (ctx, action) {
        this.textTool.add(action.text);
        ctx.setState({ dirty: true });
    };
    TextState.prototype.applyChanges = function (ctx) {
        this.store.dispatch(new OpenPanel(DrawerName.OBJECT_SETTINGS));
        if (ctx.getState().dirty) {
            this.history.add(HistoryNames.TEXT);
        }
        ctx.patchState(TEXT_STATE_DEFAULTS);
    };
    TextState.prototype.cancelChanges = function (ctx) {
        this.store.dispatch(new CloseForePanel());
        if (ctx.getState().dirty) {
            this.history.reload();
        }
        ctx.patchState(TEXT_STATE_DEFAULTS);
    };
    __decorate([
        Action(AddText),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, AddText]),
        __metadata("design:returntype", void 0)
    ], TextState.prototype, "add", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TextState, "dirty", null);
    TextState = __decorate([
        State({
            name: 'text',
            defaults: TEXT_STATE_DEFAULTS,
        }),
        __metadata("design:paramtypes", [TextToolService,
            Store,
            HistoryToolService,
            Actions])
    ], TextState);
    return TextState;
}(BaseToolState));
export { TextState };
